import { useTranslation } from 'react-i18next';

import { ProfileList } from './components/ProfileList';
import { ProfileModal } from './components/ProfileModal';
import { SearchFilters } from './components/SearchFilters';
import { SearchForm } from './components/SearchForm';
import { ProfilesProvider } from './contexts/ProfileContext';

export function Profiles() {
  const { t } = useTranslation('translation', { keyPrefix: 'pages.Profiles' });

  return (
    <ProfilesProvider>
      <div className="py-8">
        <section>
          <h1 className="text-[42px] tracking-[8.25px]">{t('title')}</h1>
          <p className="text-muted-foreground">{t('description')}</p>
        </section>

        <section className="mt-[30px] max-w-[1200px] space-y-[20px]">
          <SearchForm />
          <SearchFilters />
          <ProfileList />
        </section>
      </div>

      <ProfileModal />
    </ProfilesProvider>
  );
}
